<template>
  <el-dialog :title="mode === 'create' ? '创建培训任务' : '编辑培训任务'" :visible.sync="dialogVisible" width="800px"
    @close="handleClose" append-to-body>
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <el-form-item label="培训标题" prop="title">
        <el-input v-model="form.title" placeholder="请输入培训标题" />
      </el-form-item>

      <el-form-item label="培训分类" prop="category">
        <el-select v-model="form.category" placeholder="请选择分类" style="width: 100%">
          <el-option v-for="category in categoryOptions" :key="category.value" :label="category.label"
            :value="category.value" />
        </el-select>
      </el-form-item>

      <el-form-item label="培训资料" prop="materialsId">
        <div class="materials-section">
          <el-button type="primary" @click="handleSelectMaterials">
            {{ selectedMaterials ? "已选择资料" : "选择培训资料" }}
          </el-button>

          <div v-if="selectedMaterials" class="selected-materials">
            <div class="materials-info">
              <span class="materials-title">{{ selectedMaterials.title }}</span>

              <el-tag size="mini" style="margin-left: 8px">
                {{ selectedMaterials.category }}
              </el-tag>
              <el-button size="mini" type="text" @click="handleClearMaterials" style="margin-left: 8px">
                清除
              </el-button>
            </div>
            <div class="materials-desc">{{ selectedMaterials.description }}</div>
          </div>
        </div>
      </el-form-item>

      <el-form-item label="考试题目" prop="examId">
        <div class="exam-section">
          <el-button type="primary" @click="handleSelectExam">
            {{ selectedExam ? "已选择考试" : "选择考试题目" }}
          </el-button>

          <div v-if="selectedExam" class="selected-exam">
            <div class="exam-info">
              <span class="exam-title">{{ selectedExam.title }}</span>
              <el-tag size="mini" style="margin-left: 8px">
                {{ selectedExam.questions ? selectedExam.questions.length : 0 }}题
              </el-tag>
              <el-button size="mini" type="text" @click="handleClearExam" style="margin-left: 8px">
                清除
              </el-button>
            </div>
            <div class="exam-score">
              总分: {{ selectedExam.totalScore }}分 | 及格分: {{ selectedExam.passScore }}分
            </div>
          </div>
        </div>
      </el-form-item>

      <el-form-item label="人脸校验" prop="faceVerifyEnabled">
        <el-switch v-model="form.faceVerifyEnabled" active-text="开启" inactive-text="关闭" />
      </el-form-item>

      <el-form-item v-if="form.faceVerifyEnabled" label="校验次数" prop="faceVerifyCount">
        <el-input-number v-model="form.faceVerifyCount" :min="1" :max="5" placeholder="校验次数" style="width: 200px" />
        <span style="margin-left: 10px; color: #909399">
          开启后，视频中后段会按次数抓拍
        </span>
      </el-form-item>

      <el-form-item label="完成截止日期" prop="latestFinishTime">
        <el-date-picker
          v-model="form.latestFinishTime"
          type="date"
          placeholder="选填，不选则不限制"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd 23:59:59"
          clearable
          style="width: 200px"
        />
        <span style="margin-left: 10px; color: #909399">不填则司机端不展示</span>
      </el-form-item>

      <el-form-item label="优先级" prop="priority">
        <el-input-number v-model="form.priority" :min="1" :max="10" placeholder="优先级" style="width: 200px" />
        <span style="margin-left: 10px; color: #909399">数值越大优先级越高</span>
      </el-form-item>

      <el-form-item label="注意事项" prop="notice">
        <el-input
          v-model="form.notice"
          type="textarea"
          :rows="3"
          placeholder="选填。填写后展示在司机端，不填则不展示"
        />
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleConfirm" :loading="confirmLoading"> 确定 </el-button>
    </div>

    <!-- 选择资料对话框 -->
    <MaterialsSelectorDialog :visible.sync="materialsSelectorVisible" @confirm="handleMaterialsSelected" />

    <!-- 选择考试对话框 -->
    <ExamSelectorDialog :visible.sync="examSelectorVisible" @confirm="handleExamSelected" />
  </el-dialog>
</template>

<script>
import MaterialsSelectorDialog from "./MaterialsSelectorDialog.vue";
import ExamSelectorDialog from "./ExamSelectorDialog.vue";
import { BaseDataService } from "@/service/base-data-service";
import { saveTraining } from "@/api/new_training";
export default {
  name: "TrainingDialog",
  components: {
    MaterialsSelectorDialog,
    ExamSelectorDialog
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default: () => ({})
    },
    mode: {
      type: String,
      default: "create" // create | edit
    }
  },
  data() {
    return {
      dialogVisible: false,
      confirmLoading: false,
      form: {
        title: "",
        category: "",
        materialsId: "",
        examId: "",
        priority: 1,
        notice: "",
        faceVerifyEnabled: false,
        faceVerifyCount: 2
      },
      rules: {
        title: [{ required: true, message: "请输入培训标题", trigger: "blur" }],
        category: [{ required: true, message: "请选择培训分类", trigger: "change" }],
        examId: [{ required: true, message: "请选择考试题目", trigger: "change" }],
        faceVerifyCount: [
          {
            validator: (rule, value, callback) => {
              if (!this.form.faceVerifyEnabled) {
                callback();
                return;
              }
              if (!value || value < 1) {
                callback(new Error("请填写人脸校验次数"));
                return;
              }
              callback();
            },
            trigger: "change"
          }
        ]
      },

      // 选择器对话框
      materialsSelectorVisible: false,
      examSelectorVisible: false,

      // 分类选项
      categoryOptions: BaseDataService.trainingCategoryOpts(),

      selectedExam: null,
      selectedMaterials: null
    };
  },
  watch: {
    visible: {
      handler(val) {
        this.dialogVisible = val;
        if (val) {
          this.initForm();
        }
      },
      immediate: true
    }
  },
  methods: {
    // 初始化表单
    initForm() {
      if (this.mode === "create") {
        this.form = {
          title: "",
          category: "",
          materialsId: "",
          examId: "",
          priority: 1,
          notice: "",
          latestFinishTime: null,
          faceVerifyEnabled: false,
          faceVerifyCount: 2
        };
        this.selectedMaterials = null;
        this.selectedExam = null;
      } else {
        const data = { ...this.formData };
        if (!data.notice) {
          data.notice = data.remark || "";
        }
        if (data.faceVerifyEnabled == null) {
          data.faceVerifyEnabled = false;
        }
        if (!data.faceVerifyCount) {
          data.faceVerifyCount = 2;
        }
        if (data.latestFinishTime) {
          data.latestFinishTime = String(data.latestFinishTime).slice(0, 10) + " 23:59:59";
        } else {
          data.latestFinishTime = null;
        }
        this.form = data;
        this.selectedMaterials = this.formData.trainMaterials;
        this.selectedExam = this.formData.trainExam;
      }
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate();
      });
    },

    // 选择培训资料
    handleSelectMaterials() {
      this.materialsSelectorVisible = true;
    },

    // 选择考试题目
    handleSelectExam() {
      this.examSelectorVisible = true;
    },

    // 资料选择确认
    handleMaterialsSelected(materials) {
      this.form.materialsId = materials.id;
      this.selectedMaterials = materials;
    },

    // 考试选择确认
    handleExamSelected(exam) {
      this.form.examId = exam.id;
      this.selectedExam = exam;
    },

    // 清除资料
    handleClearMaterials() {
      this.form.materialsId = "";
      this.selectedMaterials = null;
    },

    // 清除考试
    handleClearExam() {
      this.form.examId = "";
      this.selectedExam = null;
    },

    // 确认
    handleConfirm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.confirmLoading = true;
          try {
            const data = { ...this.form };
            await saveTraining(data);
            this.$emit("confirm", data);
            this.handleClose();
          } catch (error) {
            this.$message.error("保存失败");
            console.error(error);
          } finally {
            this.confirmLoading = false;
          }
        }
      });
    },

    // 关闭
    handleClose() {
      this.dialogVisible = false;
      this.$emit("update:visible", false);
    }
  }
};
</script>

<style lang="less" scoped>
.materials-section,
.exam-section {

  .selected-materials,
  .selected-exam {
    margin-top: 12px;
    padding: 12px;
    background: #f8f9fa;
    border-radius: 4px;
    border: 1px solid #e4e7ed;

    .materials-info,
    .exam-info {
      display: flex;
      align-items: center;
      margin-bottom: 8px;

      .materials-title,
      .exam-title {
        font-weight: 600;
        color: #303133;
      }
    }

    .materials-desc,
    .exam-score {
      color: #606266;
      font-size: 14px;
    }
  }
}

.dialog-footer {
  text-align: right;
}
</style>
